import { Table } from '@mantine/core';

import { CustomTable, CustomTableMobile, CustomCopyBtn, useResponsive } from '@/shared';
import { convertWithdrawalsToTable } from '../utils/helpers/converter';
import { WithdrawalStatus } from './withdrawal-status';

import type { TWithdrawal } from '../store/types';

type Props = {
  items: TWithdrawal[];
  isLoading?: boolean;
  itemsCount?: number;
  pageSize?: number;
  currentPage?: number;
  onPageChange?: (page: number) => void;
};

export const WithdrawalsTable = (props: Props) => {
  const { items } = props;
  const { isDesktop } = useResponsive();

  const titles = [
    'ID',
    'Создан',
    // 'Обновлён',
    'Сумма',
    'Комиссия',
    'Валюта',
    'ID магазина',
    'ID метода',
    'Реквизиты',
    'Статус',
  ];

  const rows = convertWithdrawalsToTable(items).map((item) => (
    <Table.Tr key={item.id}>
      <Table.Td>{item.id}</Table.Td>
      <Table.Td>{item.created}</Table.Td>
      {/* <Table.Td>{item.updated}</Table.Td> */}
      <Table.Td>{item.amount}</Table.Td>
      <Table.Td>{item.commission}</Table.Td>
      <Table.Td>{item.currency}</Table.Td>
      <Table.Td>{item.shopId}</Table.Td>
      <Table.Td>{item.methodId}</Table.Td>
      <Table.Td>
        <CustomCopyBtn text={item.credentials} tooltipPosition="top" rightIcon />
      </Table.Td>
      <Table.Td>
        <WithdrawalStatus item={item} />
      </Table.Td>
    </Table.Tr>
  ));

  const rowsMobile = convertWithdrawalsToTable(items).map((item) => ({
    key: item.id,
    // headerActions: getActions(item),
    items: [
      { name: 'Сумма', value: `${item.amount} ${item.currency}` },
      { name: 'Метод', value: `${item.methodName} (${item.currency})` },
      { name: 'Создан', value: item.created },
      // { name: 'Обновлён', value: item.updated },
      { name: 'Статус', value: <WithdrawalStatus item={item} /> },
      { name: 'ID', value: item.id },
      { name: 'Комиссия', value: item.commission },
      { name: 'Валюта', value: item.currency },
      { name: 'ID метода', value: item.methodId },
      { name: 'ID магазина', value: item.shopId },
      { name: 'Реквизиты', value: <CustomCopyBtn text={item.credentials} tooltipPosition="top" leftIcon /> },
    ],
  }));

  return isDesktop
    ? (
      <CustomTable
        titles={titles}
        rows={rows}
        {...props}
      />
    )
    : (
      <CustomTableMobile
        rows={rowsMobile}
        headerPointsCount={4}
        {...props}
      />
    );
};
